import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  SearchPartnerTcpaRequest,
  SearchPartnerTcpaResponse,
} from '../../dto/partner-configuration-dto';

type SearchPartnerTcpaAdapterParamsOptions = Partial<
  Omit<IHttpRequest<void>, 'body'>
> & {
  httpCall?: IHttpCall;
};

export function seachPartner(
  baseUrl: string,
  payload: SearchPartnerTcpaRequest,
  options?: SearchPartnerTcpaAdapterParamsOptions,
): Promise<IHttpResponse<SearchPartnerTcpaResponse>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<SearchPartnerTcpaResponse> = {
    url: `${baseUrl}/api/v1/partner-configurations/search-partner-tcpa/`,
    method: 'GET',
    headers,
    queryParams: {
      ...payload,
    },
    schemas: {
      query: SearchPartnerTcpaRequest,
      response: SearchPartnerTcpaResponse,
    },
    ...restOptions,
  };

  return httpCall(request);
}
